// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import TaxesGql from '@/extensions/shop/store/graphql/queries/Taxes.gql';

export default {
    fetchList: (shopID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (shopID) variables.shop = parseInt(shopID);

            apolloClient
                .query({
                    query: TaxesGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_Taxes))
                .catch(err => reject(err));
        })
    // fetchTaxesPaginated: data => new Promise((resolve, reject) => {

    //     let filters = []
    //     _.each(data.filters, entry => filters.push(entry))

    //     apolloClient.query({
    //         query: TaxesPaginatedGql,
    //         variables: {
    //             currentPage: _.get(data, 'pageInfo.currentPage', 1),
    //             perPage: _.get(data, 'pageInfo.perPage', 25),
    //             order: _.get(data, 'variables.order', 'id'),
    //             direction: _.get(data, 'variables.direction', 'asc'),
    //             filters,
    //         }
    //     })
    //         .then(({data}) => resolve(data))
    //         .catch(err => reject(err))
    // }),
    // fetchTax: id => {
    //     if (id === undefined) throw new Error('required argument is missing')

    //     return new Promise((resolve, reject) => {
    //         apolloClient.query({
    //             query: TaxGql,
    //             variables: { id }
    //         })
    //             .then(({data}) => resolve(data.CO_Tax))
    //             .catch(err => reject(err))
    //     })
    // },
    // create: tax => {
    //     if (tax === undefined) throw new Error('required argument is missing')

    //     tax = _.removeDeepByKey(tax, '__typename')
    //     return new Promise((resolve, reject) => {
    //         apolloClient.mutate({
    //             mutation: CreateTaxGql,
    //             variables: { tax }
    //         })
    //             .then(({data}) => {
    //                 apolloClient.clearStore()
    //                 resolve(data.CO_CreateTax)
    //             })
    //             .catch(err => reject(err))
    //     })
    // },
    // update: tax => {
    //     if (tax === undefined) throw new Error('required argument is missing')

    //     tax = _.removeDeepByKey(tax, '__typename')
    //     return new Promise((resolve, reject) => {
    //         apolloClient.mutate({
    //             mutation: UpdateTaxGql,
    //             variables: { tax }
    //         })
    //             .then(({data}) => {
    //                 apolloClient.clearStore()
    //                 resolve(data.CO_UpdateTax)
    //             })
    //             .catch(err => reject(err))
    //     })
    // },
    // delete: id => {
    //     if (id === undefined) throw new Error('required argument is missing')

    //     return new Promise((resolve, reject) => {
    //         apolloClient.mutate({
    //             mutation: DeleteTaxGql,
    //             variables: { id }
    //         })
    //             .then(({data}) => {
    //                 apolloClient.clearStore()
    //                 resolve(data.CO_DeleteTax)
    //             })
    //             .catch(err => reject(err))
    //     })
    // }
};
